/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useState} from 'react'

import {Card, StyledBody, StyledAction} from 'baseui/card'
import {SIZE} from 'baseui/spinner'
import {Button} from 'baseui/button'

import LoadingSpinner from '../../components/app/loading-spinner'
import StatsProgress from '../student-progress/stats-progress'
import StatsChallenges from '../student-progress/stats-challenges'
import firebase from 'firebase/compat/app'

const StudentCard = ({name, uid, data, course, onClick}) => {
  const [isReady, setIsReady] = useState(false)
  const [thumbPath, setThumbPath] = React.useState(
    'https://firebasestorage.googleapis.com/v0/b/sotsc-platform-dev.appspot.com/o/sotsc-public%2Fimages%2Fui%2Fhud-player.svg?alt=media&token=26abc53e-d058-4663-a66e-308e588cf00b',
  )

  const currentChapterIndex = data.Story ? data.Story.chapterIdx : 0
  const currentChapter = data.chapters ? data.chapters[currentChapterIndex].completed : 0
  const totalCompleted = data.Story ? data.Story.currBookCompleted : 0
  const totalBookChallenges = course ? course.books[0].totalBookChallenges : 0
  const currentChapterChallenges = course.chapters[currentChapterIndex]
    ? course.chapters[currentChapterIndex].totalChallenges
    : 0

  var storage = firebase.storage()
  var storageRef = storage.ref()
  const filePath = `sotsc-public/images/profile-icons/`
  const fileref = storageRef.child(filePath + uid + '/icon.png')

  if (!isReady) {
    new Promise(() => {
      fileref
        .getDownloadURL()
        .then(url => {
          setThumbPath(url)
        })
        .catch(error => {
          console.error(`error getting url for ${filePath}`, error)
        })
    }).then(setIsReady(true))
  }

  return !isReady ? (
    <LoadingSpinner $size={SIZE.large} />
  ) : (
    <Card
      id={'studentCard'}
      overrides={{
        Root: {
          style: {
            position: 'relative',
            minWidth: '400px',
            margin: '15px 15px 0px 15px',
            display: 'inline-block',
            whiteSpace: 'normal',
          },
        },
        Title: {
          style: {whiteSpace: 'nowrap'},
        },
        Contents: {
          style: {flexDirection: 'column', height: 'auto'},
        },
        Thumbnail: {
          style: {float: 'left'},
        },
      }}
      title={name}
      thumbnail={thumbPath}
    >
      <StyledBody>{'Working on Chapter ' + (currentChapterIndex + 1)}</StyledBody>
      <StatsChallenges
        challenges={currentChapterChallenges}
        completed={currentChapter}
      ></StatsChallenges>
      <StatsProgress progress={totalCompleted} successValue={totalBookChallenges}></StatsProgress>
      <StyledAction>
        <Button
          onClick={e => {
            onClick(uid, e)
          }}
          overrides={{
            BaseButton: {style: {width: '100%'}},
          }}
        >
          Select
        </Button>
      </StyledAction>
    </Card>
  )
}

export default StudentCard
